"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var core_1 = require("@dynamynd/core");

var formik_1 = require("formik");

var react_1 = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var redux_1 = require("redux");

var components_1 = require("../../components");

var enums_1 = require("../../enums");

var store_1 = require("../../store");

var validation_1 = require("../../validation");

var PhoneInput_1 = __importDefault(require("../PhoneInput/PhoneInput"));

var styled_1 = require("../styled");

var FormikConnected_1 = __importDefault(require("./FormikConnected"));

var PersonalDetailsInputs_1 = require("./PersonalDetailsInputs");

var TermsAndConditionsBox_1 = __importDefault(require("./TermsAndConditionsBox"));

var TITLES = ['How do you prefer to register?', 'Let’s know each other']; // todo create HOC - PhoneRegistrationFormComponent & EmailRegistrationFormComponent

var PhoneRegistrationFormComponent =
/** @class */
function (_super) {
  __extends(PhoneRegistrationFormComponent, _super);

  function PhoneRegistrationFormComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.setPageTitle = function (activeStep) {
      var setPageTitle = _this.props.setPageTitle;
      var title = TITLES[activeStep];
      setPageTitle(title);
    };

    _this.validatePhone = function (props) {
      var validPhoneCheck = _this.props.validPhoneCheck;
      var errors = props.errors,
          setFieldTouched = props.setFieldTouched,
          setFieldValue = props.setFieldValue,
          setSubmitting = props.setSubmitting,
          currentPhone = props.values.phoneNumber;
      var _a = _this.props.phoneValidation,
          validatedPhone = _a.phone,
          validated = _a.validated,
          phoneAvailable = _a.phoneAvailable;
      setFieldTouched(enums_1.FieldNames.phoneNumber);

      if (currentPhone && currentPhone !== validatedPhone && !errors.phoneNumber) {
        setSubmitting(true);
        validPhoneCheck(currentPhone);
      } else if (currentPhone === validatedPhone && validated) {
        setFieldValue(enums_1.FieldNames.phoneValid, phoneAvailable);
        setSubmitting(false);
      }
    };

    _this.formatPhone = function (value, previousValue) {
      if (!value) return value;
      var currentValue = value.replace(/[^\d]/g, '');

      if (!previousValue || value.length > previousValue.length) {
        if (currentValue.length <= 3) return currentValue;
        if (currentValue.length === 3) return "(" + currentValue + ")";
        if (currentValue.length <= 6) return "(" + currentValue.slice(0, 3) + ") " + currentValue.slice(3);
        if (currentValue.length === 6) return "(" + currentValue.slice(0, 3) + ") " + currentValue.slice(3) + "-";
        return "(" + currentValue.slice(0, 3) + ") " + currentValue.slice(3, 6) + "-" + currentValue.slice(6, 13);
      }

      return value;
    };

    _this.onPhoneChanged = function (props) {
      props.setFieldValue(enums_1.FieldNames.phoneValid, true);
    };

    return _this;
  }

  PhoneRegistrationFormComponent.prototype.componentDidMount = function () {
    this.setPageTitle(this.props.activeStep);
  };

  PhoneRegistrationFormComponent.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.activeStep !== this.props.activeStep) {
      this.setPageTitle(this.props.activeStep);
    }
  };

  PhoneRegistrationFormComponent.prototype.onPhoneValidationStateChange = function (prevPhoneValidation, nextPhoneValidation, formikProps) {
    var setFieldValue = formikProps.setFieldValue,
        setSubmitting = formikProps.setSubmitting;
    var prevPhone = prevPhoneValidation.phone,
        prevValidatedPhoneChecked = prevPhoneValidation.validated;
    var nextPhone = nextPhoneValidation.phone,
        validatedPhoneAvailable = nextPhoneValidation.phoneAvailable,
        validatedPhoneChecked = nextPhoneValidation.validated;

    if (prevPhone === nextPhone && validatedPhoneChecked !== prevValidatedPhoneChecked) {
      setFieldValue(enums_1.FieldNames.phoneValid, validatedPhoneAvailable);
      setSubmitting(false);
    } else if (prevPhone !== nextPhone) {
      setSubmitting(false);
    }
  };

  PhoneRegistrationFormComponent.prototype.isContinueButtonDisabled = function (props) {
    var errors = props.errors,
        touched = props.touched;
    var _a = this.props.phoneValidation,
        validated = _a.validated,
        phoneAvailable = _a.phoneAvailable;
    var phoneCheckedAndAvailable = validated && phoneAvailable;
    var signupCodeParamAvailable = false;
    var params = core_1.locationWebService.parseQueryParams(core_1.locationWebService.location.search);

    if (params && Object.keys(params).length > 0) {
      signupCodeParamAvailable = true;
    }

    if (signupCodeParamAvailable === true) {
      return !touched.phoneNumber || !phoneCheckedAndAvailable || !(props.touched.phoneNumber && phoneCheckedAndAvailable && !errors.phoneNumber && !errors.phoneNumberConfirm && !errors.phoneValid && !errors.password && !errors.passwordConfirm && !errors.termsAccepted && props.values.complianceTermsAccepted);
    }

    return !touched.phoneNumber || !phoneCheckedAndAvailable || !(props.touched.phoneNumber && phoneCheckedAndAvailable && !errors.phoneNumber && !errors.phoneNumberConfirm && !errors.phoneValid && !errors.password && !errors.passwordConfirm && !errors.termsAccepted);
  };

  PhoneRegistrationFormComponent.prototype.setInitialAvatarValue = function (dirty, values) {
    var avatars = this.props.avatars;

    if (!dirty) {
      return avatars[0] ? avatars[0].id : '';
    }

    return values.avatar;
  };

  PhoneRegistrationFormComponent.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        previousHandler = _a.previousHandler,
        nextHandler = _a.nextHandler,
        activeStep = _a.activeStep,
        MaskedInputDate = _a.screenProps.components.MaskedInputDate,
        initialValues = _a.initialValues,
        navigation = _a.navigation,
        showTerms = _a.showTerms,
        showComplianceTerms = _a.showComplianceTerms,
        avatars = _a.avatars,
        activeBreakpoint = _a.activeBreakpoint,
        phoneValidation = _a.phoneValidation,
        updating = _a.updating,
        _onSubmit = _a.onSubmit;
    var validated = phoneValidation.validated,
        phone = phoneValidation.phone;
    var waitingForPhoneValidation = !!phone && !validated;
    return react_1.default.createElement(formik_1.Formik, {
      initialValues: initialValues,
      onSubmit: function onSubmit(values, _a) {
        var setSubmitting = _a.setSubmitting;
        setSubmitting(true);

        _onSubmit(values);
      },
      validationSchema: validation_1.registrationValidationSchema,
      render: function render(props) {
        var dirty = props.dirty,
            values = props.values;

        var avatarInitialSelection = _this.setInitialAvatarValue(dirty, values);

        return react_1.default.createElement(components_lib_1.Steps, {
          activeStep: activeStep
        }, react_1.default.createElement(components_lib_1.ColumnCentered, null, react_1.default.createElement(components_1.FormInputGroup, null, react_1.default.createElement(FormikConnected_1.default, {
          phoneValidation: phoneValidation,
          onPhoneValidated: _this.onPhoneValidationStateChange,
          formik: __assign({}, props)
        }), react_1.default.createElement(PhoneInput_1.default, __assign({
          placeholder: enums_1.FieldPlaceHolders.phoneNumber,
          label: enums_1.FieldLabels.phoneNumber,
          name: enums_1.FieldNames.phoneNumber,
          onBlur: function onBlur() {
            _this.validatePhone(props);
          },
          onChangeText: function onChangeText() {
            _this.onPhoneChanged(props);
          },
          linkedField: enums_1.FieldNames.phoneValid,
          isError: !!props.errors.phoneValid,
          isLoading: waitingForPhoneValidation,
          isDisabled: waitingForPhoneValidation,
          accessibilityLabel: "Enter your phone number"
        }, props)), react_1.default.createElement(PhoneInput_1.default, __assign({
          placeholder: enums_1.FieldPlaceHolders.phoneNumberConfirm,
          label: enums_1.FieldLabels.phoneNumberConfirm,
          name: enums_1.FieldNames.phoneNumberConfirm,
          isDisabled: waitingForPhoneValidation,
          accessibilityLabel: "Confirm your phone number"
        }, props)), react_1.default.createElement(components_lib_1.FormInput, __assign({
          placeholder: enums_1.FieldPlaceHolders.password,
          name: enums_1.FieldNames.password,
          isSecure: true,
          allowPasswordReveal: true,
          isDisabled: waitingForPhoneValidation,
          accessibilityLabel: "Enter your password"
        }, props))), react_1.default.createElement(components_lib_1.ImagePickerContainer, {
          activeBreakpoint: activeBreakpoint
        }, react_1.default.createElement(components_lib_1.StyledInputLabel, null, enums_1.FieldLabels.avatar), react_1.default.createElement(components_lib_1.ImagePickerWithForm, __assign({
          collection: avatars,
          initialSelectedId: avatarInitialSelection,
          name: enums_1.FieldNames.avatar
        }, props))), react_1.default.createElement(TermsAndConditionsBox_1.default, __assign({
          showTerms: showTerms,
          showComplianceTerms: showComplianceTerms
        }, props)), react_1.default.createElement(styled_1.AuthButtonsContainer, null, react_1.default.createElement(components_lib_1.RowWrapper, null, react_1.default.createElement(components_lib_1.Button, {
          type: components_lib_1.ButtonTypeEnum.primary,
          text: enums_1.FieldLabels.continue,
          uppercase: true,
          disabled: _this.isContinueButtonDisabled(props),
          accessibilityLabel: enums_1.FieldLabels.continue,
          onPress: nextHandler
        })))), react_1.default.createElement(PersonalDetailsInputs_1.PersonalDetailsInputs, __assign({
          updating: updating,
          navigation: navigation,
          previousHandler: previousHandler,
          activeBreakpoint: activeBreakpoint,
          DateInputComponent: MaskedInputDate
        }, props)));
      }
    });
  };

  return PhoneRegistrationFormComponent;
}(react_1.Component);

exports.PhoneRegistrationFormComponent = PhoneRegistrationFormComponent;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    registerUser: redux_1.bindActionCreators(store_1.registerSubmitActionCreator, dispatch),
    validPhoneCheck: redux_1.bindActionCreators(store_1.validPhoneCheckActionCreator, dispatch)
  };
};

var mapStateToProps = function mapStateToProps(state) {
  var phoneValidation = store_1.phoneValidationSelector(state);
  var updating = store_1.authUpdatingSelector(state);
  return {
    phoneValidation: phoneValidation,
    updating: updating
  };
};

var connector = react_redux_1.connect(mapStateToProps, mapDispatchToProps);
var hoc = redux_1.compose(connector);
exports.default = hoc(PhoneRegistrationFormComponent);